import _ from 'underscore'

Date.prototype.sperate = function () {
  var yyyy = this.getFullYear().toString()
  var MM = pad(this.getMonth() + 1, 2)
  var dd = pad(this.getDate(), 1)
  var hh = pad(this.getHours(), 2)
  var mm = pad(this.getMinutes(), 2)
  var ss = pad(this.getSeconds(), 2)

  function pad(number, length) {
    var str = '' + number
    while (str.length < length) {
      str = '0' + str
    }

    return str
  }

  return {
    year: yyyy,
    month: MM,
    day: dd,
    hour: hh,
    minutes: mm,
    seconds: ss,
  }
}

function milliSecToDay(t) {
  var cd = 24 * 60 * 60 * 1000,
    ch = 60 * 60 * 1000,
    d = Math.floor(t / cd),
    h = Math.floor((t - d * cd) / ch),
    m = Math.round((t - d * cd - h * ch) / 60000),
    pad = function (n) {
      return n < 10 ? '0' + n : n
    }
  if (m === 60) {
    h++
    m = 0
  }

  if (h === 24) {
    d++
    h = 0
  }
  var day = d > 0 ? d + '일' + ' ' : ''
  return day + pad(h) + ':' + pad(m) + ' 남음'
}
export function dateStringToMilliseconds(dateString) {
  if (typeof dateString === 'string') {
    var year = dateString.substring(0, 4)
    var month = dateString.substring(4, 6)
    var day = dateString.substring(6, 8)
    var hour = dateString.substring(8, 10)
    var min = dateString.substring(10, 12)
    var sec = dateString.substring(12, 14)
    var milliSec = +new Date(year, month - 1, day, hour, min, sec)

    return milliSec
  }
}

export function remainDate(dateString) {
  var milliSec = dateStringToMilliseconds(dateString)
  var remainSec = milliSec - _.now()

  return milliSecToDay(remainSec)
}
